module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Tinymce Editor"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("UI Element")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Tinymce Editor")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h5', [_vm._v("Click to upload files")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("Click to upload")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("jpg/png files with a size less than 500kb")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("FileList with thumbnail")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.fileList2,
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("Click to upload")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("jpg/png files with a size less than 500kb")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("FileList with thumbnail")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3121d09d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ui/Upload.vue
// module id = 1284
// module chunks = 2